import { IndianRupee, MapPin, Clock, BellRing, Smartphone } from "lucide-react";
import { pt } from "@/lib/pt";

const PERKS = [
  { Icon: IndianRupee, t: "Earn every day", d: "Get paid for every pickup you complete. See your earnings live in the app." },
  { Icon: MapPin, t: "Choose your area", d: "Set your home location and how far you want to go. Pickups come from near you." },
  { Icon: Clock, t: "Work your own hours", d: "Go online when you are free, between 8 AM and 8 PM. Go offline any time." },
  { Icon: BellRing, t: "Pickups come to you", d: "Customers book in the app. You get an alert, tap Accept, and go." },
];
const STEPS = ["Sign up with your mobile", "Upload KYC documents", "Go online and accept pickups"];

export const PartnerHero = () => (
  <div className="ks-page space-y-5" data-testid="partner-welcome">
    <div className="relative -mx-4 overflow-hidden rounded-b-[2.5rem] bg-[#0D3B2B]">
      <img src="/partner-welcome.webp" alt="" className="h-72 w-full object-cover opacity-90 sm:h-80" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0D3B2B] via-[#0D3B2B]/30 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 space-y-1 p-5 text-white">
        <p className="inline-block rounded-full bg-[#2E9E6B] px-3 py-1 text-xs font-bold" data-testid="partner-welcome-tag">{pt("Kindsaver Partner · Jaipur")}</p>
        <h1 className="font-display text-3xl font-extrabold leading-tight sm:text-4xl" data-testid="partner-welcome-title">{pt("Welcome, partner!")}</h1>
        <p className="text-base text-[#CFEBDD]">{pt("Collect scrap near your home, earn daily and help keep Jaipur clean.")}</p>
        <button type="button" onClick={() => document.getElementById("partner-start")?.scrollIntoView({ behavior: "smooth" })} data-testid="partner-welcome-start-btn"
          className="mt-2 h-12 rounded-full bg-white px-6 text-base font-bold text-[#0D3B2B] transition-transform active:scale-[.97]">{pt("Start now")} ↓</button>
      </div>
    </div>
    <img src="/logo-tagline.webp" alt="kindsaver · Kind. Clean. Bold." className="mx-auto h-16 w-auto sm:h-20" data-testid="partner-welcome-logo" />
    <div className="grid grid-cols-2 gap-3">
      {PERKS.map(({ Icon, t, d }, i) => (
        <div key={t} className="ks-rise rounded-3xl bg-white p-4 shadow-sm" style={{ animationDelay: `${i * 80}ms` }} data-testid={`partner-perk-${i}`}>
          <span className="mb-2 flex h-12 w-12 items-center justify-center rounded-2xl bg-[#E7F6EE] text-[#2E9E6B]"><Icon className="h-7 w-7" /></span>
          <p className="font-display text-base font-bold text-[#0D3B2B]">{pt(t)}</p>
          <p className="mt-1 text-xs leading-snug text-[#4A6358]">{pt(d)}</p>
        </div>
      ))}
    </div>
    <div className="rounded-3xl border-2 border-dashed border-[#BFE3CF] bg-[#F9FCFA] p-4" data-testid="partner-steps">
      <p className="mb-3 flex items-center gap-2 font-display font-bold text-[#0D3B2B]"><Smartphone className="h-5 w-5 text-[#2E9E6B]" />{pt("Start in 3 easy steps")}</p>
      <ol className="space-y-2">
        {STEPS.map((s, i) => (
          <li key={s} className="flex items-center gap-3 text-sm font-semibold text-[#0D3B2B]">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#0D3B2B] text-sm font-bold text-white">{i + 1}</span>{pt(s)}</li>
        ))}
      </ol>
    </div>
  </div>
);
